<div class="vehicle-wrapper">
  <div class="top-header">
    <h3>{{ isEditMode ? 'Edit Cluster' : 'Create Cluster' }}</h3>
    <p>Manage cluster details and values</p>
  </div>

  <form [formGroup]="clusterForm" (ngSubmit)="submitCluster()">
    <div class="form-row">
      <div class="form-item">
        <label>Cluster Name <small>*</small></label>
        <input type="text" formControlName="name" />
        <div class="error" *ngIf="clusterForm.get('name')?.invalid && clusterForm.get('name')?.touched">
          <small>Name is required</small>
        </div>
      </div>
      <div class="form-item">
        <label>Description</label>
        <input type="text" formControlName="description" />
      </div>
      <div class="form-item">
        <label>Status</label>
        <select formControlName="is_active">
          <option [ngValue]="true">Active</option>
          <option [ngValue]="false">Inactive</option>
        </select>
      </div>
    </div>

    <div class="button-row">
      <button type="submit" class="btn-save">
        <fa-icon [icon]="['fas', 'square-plus']"></fa-icon>
        Save
      </button>
      <button type="button" class="btn-cancel" (click)="cancel()">
        <fa-icon [icon]="['fas', 'square-xmark']"></fa-icon>
        Cancel
      </button>
    </div>
  </form>

  <div *ngIf="clusterId" class="cluster-values-section">
    <div class="top-header sub-header">
      <h3>Cluster Values</h3>
    </div>

    <form [formGroup]="valueForm" (ngSubmit)="submitValue()">
      <div class="form-row">
        <div class="form-item">
          <label>Value <small>*</small></label>
          <input type="text" formControlName="value" />
          <div class="error" *ngIf="valueForm.get('value')?.invalid && valueForm.get('value')?.touched">
            <small>Value is required</small>
          </div>
        </div>
        <div class="form-item">
          <label>Sort Order</label>
          <input type="number" formControlName="sort_order" />
        </div>
        <div class="form-item">
          <label>Status</label>
          <select formControlName="is_active">
            <option [ngValue]="true">Active</option>
            <option [ngValue]="false">Inactive</option>
          </select>
        </div>
      </div>
      <div class="button-row">
        <button type="submit" class="btn-save">
          {{ isValueEdit ? 'Update Value' : 'Add Value' }}
        </button>
        <button type="button" class="btn-cancel" (click)="resetValueForm()">Clear</button>
      </div>
    </form>

    <div class="responsive-table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Value</th>
            <th>Sort</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let value of clusterValues">
            <td>{{ value.value }}</td>
            <td>{{ value.sort_order }}</td>
            <td>{{ value.is_active ? 'Active' : 'Inactive' }}</td>
            <td>
              <button class="action-button bt-edit" (click)="editValue(value)" title="Edit">
                <fa-icon [icon]="['fas', 'pen']"></fa-icon>
              </button>
              <button class="action-button bt-delete" (click)="deleteValue(value.id)" title="Delete">
                <fa-icon [icon]="['fas', 'trash']"></fa-icon>
              </button>
            </td>
          </tr>
          <tr *ngIf="clusterValues.length === 0">
            <td colspan="4">No values found.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
